// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-f0e9ac","sapcnqr-overlay":"sapcnqr-overlay-cab200","sapcnqr-overlay__content":"sapcnqr-overlay__content-7b8595"};